module.exports = __webpack_public_path__ + "static/media/woman (2).6cb32aa5.png";